import React from "react";

function Canvas_Text() {
  return (
    <div>
      <h1>Canvas_Text Component</h1>
      <p>This is the Canvas Text tutorial page content.</p>
    </div>
  );
}

export default Canvas_Text;
